import { Helmet } from "react-helmet";
import LandingLayout from "../section/landing/landing-layout";

const LandingPage = () => {
    <Helmet>
        <title>Digital Tourism | Smart Travel Technology Solutions</title>
        <meta name="description" content="Explore innovative travel-tech solutions with Digital Tourism, Sri Lanka’s leading digital tourism tech solutions company." />
        <meta name="keywords" content="Digital Tourism Sri Lanka, travel tech solutions, tourism technology, Sri Lanka travel platforms, smart travel tools, digital travel solutions" />
    </Helmet>

    return (
        <>
            <LandingLayout />
        </>
    );
}

export default LandingPage;